import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchAbandoned = createAsyncThunk('abandoned/fetch', async () => {
  // Fetch all statuses to show both active and abandoned carts
  const res = await axios.get('/abandoned-carts?status=all');
  return res.data;
});

const abandonedSlice = createSlice({
  name: 'abandoned',
  initialState: { items: [], status: 'idle', error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchAbandoned.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchAbandoned.fulfilled, (s, a) => { s.status = 'succeeded'; s.items = a.payload; })
     .addCase(fetchAbandoned.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; });
  }
});

export default abandonedSlice.reducer;


